var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.418 6.374C.418 3.21 3.017.666 6.197.666c1.52 0 2.84.793 3.804 1.705.966-.912 2.285-1.705 3.805-1.705 3.18 0 5.779 2.544 5.779 5.708V6.4c-.002.027-.002.056-.003.086-.01.41-.027 1.053-.3 1.798-.294.807-.862 1.679-1.916 2.586l-6.801 6.244a.833.833 0 01-1.127 0L2.637 10.87C1.582 9.962 1.014 9.09.72 8.283.448 7.538.431 6.894.42 6.485a23.992 23.992 0 00-.002-.11z"
  })));
};
export default SvgLike;